// src/components/AdminLogoutButton.js
import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { useNavigate } from 'react-router-dom';

// Accetta una prop onLogout per eseguire azioni aggiuntive (es. chiudere nav mobile)
const AdminLogoutButton = ({ onLogout }) => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            if (onLogout) {
                onLogout(); // Esegui callback se fornito
            }
            navigate('/'); // Torna alla home dopo il logout
            console.log("Logout effettuato");
        } catch (error) {
            console.error("Errore logout:", error);
            // Potresti mostrare un messaggio all'utente qui
        }
    };

    // Usa la classe CSS definita in Navbar.css (header) o Footer.css (footer)
    return (
        <button
            onClick={handleLogout}
            className="admin-logout-button"
            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}
        >
            Logout
        </button>
    );
};

export default AdminLogoutButton;